import { useState } from 'react';
import UsageInfo from '../../components/UsageInfo';

const INP = "w-full border-2 border-gray-100 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 focus:outline-none focus:border-blue-400 focus:ring-4 focus:ring-blue-50 bg-white transition-all placeholder-gray-300 shadow-sm shadow-blue-50/20";

export default function WebSiteSEO() {
  const [kayit, setKayit] = useState(false);
  const [baslik, setBaslik] = useState('HOTELFLOW - ŞEHRİN KALBİNDE LÜKS VE KONFOR');
  const [desc, setDesc] = useState('HotelFlow\'da unutulmaz bir konaklama deneyimi yaşayın. Modern odalarımız, Spa hizmetlerimiz ve Gurme restoranımızla sizi bekliyoruz. Online rezervasyon için tıklayın.');
  const [keywords, setKeywords] = useState('otel, lüks konaklama, tatil rezervasyonu, spa, butik otel');
  const [googleId, setGoogleId] = useState('G-WEBFLOW2026');
  const [fbPixel, setFbPixel] = useState('');
  const [schema, setSchema] = useState(true);
  const [sitemap, setSitemap] = useState(true);
  const [robots, setRobots] = useState('index, follow');

  const baslikUzunluk = baslik.length;
  const descUzunluk = desc.length;

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50 animate-fadeIn" style={{ transform: 'translateZ(0)' }}>
      
      {/* Premium Header */}
      <div className="bg-white rounded-[2.5rem] border border-gray-200 shadow-sm p-6 md:p-8 relative overflow-hidden">
        <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 bg-sky-50 rounded-full blur-3xl opacity-60 pointer-events-none" style={{ transform: 'translateZ(0)', willChange: 'transform' }}></div>
        <div className="relative flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div className="flex items-center gap-6 min-w-0">
            <div className="w-16 h-16 bg-gradient-to-br from-sky-500 to-blue-700 rounded-2xl flex-shrink-0 flex items-center justify-center text-white text-3xl shadow-2xl shadow-sky-200">🔍</div>
            <div className="min-w-0">
              <h1 className="text-2xl md:text-3xl font-black text-gray-900 tracking-tighter truncate uppercase">SEO & META Ayarları</h1>
              <p className="text-sm font-bold text-gray-400 mt-1 uppercase tracking-widest truncate">Arama motoru görünürlüğü ve analitik takip kodları</p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
        {/* Sol Kolon - Form Alanları */}
        <div className="lg:col-span-12 xl:col-span-7 space-y-7">
          
          {/* Meta Bilgi Kartı */}
          <div className="bg-white rounded-[2.5rem] border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-8 py-5 border-b border-gray-50 flex items-center gap-3 bg-gray-50/30">
               <span className="text-xl">📝</span>
               <h3 className="font-black text-xs text-gray-800 uppercase tracking-widest">Temal/Meta Verileri</h3>
            </div>
            <div className="p-8 space-y-8">
               <div>
                  <div className="flex items-center justify-between mb-3 px-1">
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">SAYFA BAŞLIĞI (TITLE)</label>
                    <span className={`text-[10px] font-black px-2 py-1 rounded-lg ${baslikUzunluk > 60 ? 'bg-rose-50 text-rose-500' : 'bg-emerald-50 text-emerald-600'}`}>
                      {baslikUzunluk}/60
                    </span>
                  </div>
                  <input 
                    value={baslik} 
                    onChange={e => setBaslik(e.target.value)} 
                    className={INP + " transition-shadow transform duration-200"}
                    placeholder="Otel Adı - Kısa Slogan..." 
                  />
                  <div className="mt-2 h-1 w-full bg-gray-50 rounded-full overflow-hidden">
                     <div className={`h-full transition-[width,background-color] duration-500 ${baslikUzunluk > 60 ? 'bg-rose-500' : 'bg-emerald-500'}`} style={{ width: `${Math.min((baslikUzunluk/60)*100, 100)}%` }} />
                  </div>
               </div>

               <div>
                  <div className="flex items-center justify-between mb-3 px-1">
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">META AÇIKLAMASI (DESCRIPTION)</label>
                    <span className={`text-[10px] font-black px-2 py-1 rounded-lg ${descUzunluk > 160 ? 'bg-rose-50 text-rose-500' : 'bg-emerald-50 text-emerald-600'}`}>
                      {descUzunluk}/160
                    </span>
                  </div>
                  <textarea 
                    value={desc} 
                    onChange={e => setDesc(e.target.value)}
                    className={INP + ' resize-none min-h-[120px]'} 
                    rows={4}
                    placeholder="Sitenizi tanımlayan 150-160 karakterlik özet içerik..." 
                  />
                  <div className="mt-2 h-1 w-full bg-gray-50 rounded-full overflow-hidden">
                     <div className={`h-full transition-all duration-500 ${descUzunluk > 160 ? 'bg-rose-500' : 'bg-emerald-500'}`} style={{ width: `${Math.min((descUzunluk/160)*100, 100)}%` }} />
                  </div>
               </div>

               <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-3 px-1">ANAHTAR KELİMELER (KEYWORDS)</label>
                  <input 
                    value={keywords} 
                    onChange={e => setKeywords(e.target.value)} 
                    className={INP}
                    placeholder="otel, konaklama, tatil, butik otel..." 
                  />
                  <p className="text-[9px] font-bold text-gray-300 mt-2 uppercase tracking-widest ml-1">Kelimeleri virgül (,) ile ayırın.</p>
               </div>
            </div>
          </div>

          {/* Analitik Kartı */}
          <div className="bg-white rounded-[2.5rem] border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-8 py-5 border-b border-gray-50 flex items-center gap-3 bg-gray-50/30">
               <span className="text-xl">📊</span>
               <h3 className="font-black text-xs text-gray-800 uppercase tracking-widest">Takip ve Analitik Kodları</h3>
            </div>
            <div className="p-8 grid grid-cols-1 md:grid-cols-2 gap-6">
               <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-3 px-1">GOOGLE ANALYTICS G-ID</label>
                  <input 
                    value={googleId} 
                    onChange={e => setGoogleId(e.target.value)} 
                    className={INP}
                    placeholder="G-XXXXXXX" 
                  />
               </div>
               <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-3 px-1">FACEBOOK PIXEL ID</label>
                  <input 
                    value={fbPixel} 
                    onChange={e => setFbPixel(e.target.value)} 
                    className={INP}
                    placeholder="1234567890..." 
                  />
               </div>
            </div>
          </div>
        </div>

        {/* Sağ Kolon - Önizleme ve Teknik */}
        <div className="lg:col-span-12 xl:col-span-5 space-y-7">
          
          {/* Realistik Google Önizleme */}
          <div className="bg-white rounded-[2.5rem] border-2 border-indigo-100 shadow-2xl shadow-indigo-100 overflow-hidden relative group">
             <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-100 transition-opacity">
                <span className="text-xs font-black text-indigo-400 uppercase tracking-widest">LIVE PREVIEW</span>
             </div>
             <div className="px-8 py-8 md:py-12 space-y-6">
                <div>
                  <div className="flex items-center gap-3 mb-2">
                     <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-xs">🌐</div>
                     <div>
                        <p className="text-xs text-gray-900 font-medium leading-none">HOTELFLOW TEST OTEL</p>
                        <p className="text-[10px] text-gray-500 leading-none mt-1">https://www.hotelflow.com <span className="ml-1">› ...</span></p>
                     </div>
                  </div>
                  <h2 className="text-xl font-medium text-blue-800 hover:underline cursor-pointer leading-tight mb-2">
                    {baslik || 'SAYFA BAŞLIĞI BURADA GÖRÜNECEK'}
                  </h2>
                  <p className="text-sm text-gray-600 leading-relaxed line-clamp-3">
                    <span className="text-gray-400 mr-1">10 Mar 2026 —</span>
                    {desc || 'Arama motoru sonuç sayfasında web sitenizin altında görünecek meta açıklama metni burada simüle edilmektedir.'}
                  </p>
                </div>
             </div>
             <div className="bg-indigo-50/50 px-8 py-4 border-t border-indigo-100 flex items-center justify-between">
                <span className="text-[9px] font-black text-indigo-400 uppercase tracking-widest">Google Arama Simülasyonu</span>
                <div className="flex gap-1">
                   {[1,2,3,4,5].map(i => <span key={i} className="text-yellow-400 text-xs">★</span>)}
                </div>
             </div>
          </div>

          {/* Teknik SEO Ayarları */}
          <div className="bg-white rounded-[2.5rem] border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-8 py-5 border-b border-gray-50 flex items-center gap-3 bg-gray-50/30">
               <span className="text-xl">⚙️</span>
               <h3 className="font-black text-xs text-gray-800 uppercase tracking-widest">Teknik Yapılandırma</h3>
            </div>
            <div className="p-8 space-y-6">
               {[
                 { id:'schema', label: 'SCHEMA.ORG (JSON-LD)', desc: 'Yapısal Veri İşaretleme', val: schema, set: setSchema },
                 { id:'sitemap', label: 'AUTO SITEMAP.XML', desc: 'Otomatik Site Haritası', val: sitemap, set: setSitemap },
               ].map(item => (
                 <div key={item.id} className="flex items-center justify-between group cursor-pointer" onClick={() => item.set(p => !p)}>
                    <div>
                      <p className="text-[11px] font-black text-gray-800 uppercase tracking-tighter">{item.label}</p>
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-1 leading-none">{item.desc}</p>
                    </div>
                    <div className={`relative w-12 h-7 rounded-full transition-colors duration-300 shadow-inner ${item.val ? 'bg-sky-500 shadow-sky-100' : 'bg-gray-200'}`}>
                       <span className={`absolute top-1 left-1 w-5 h-5 bg-white rounded-full shadow-lg transition-transform duration-300 ${item.val ? 'translate-x-5' : 'translate-x-0'}`} />
                    </div>
                 </div>
               ))}

               <div className="pt-4">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-3 px-1">ROBOTS.TXT DIREKTIFILERI</label>
                  <div className="relative">
                    <select 
                      value={robots} 
                      onChange={e => setRobots(e.target.value)}
                      className="w-full border-2 border-gray-100 rounded-2xl px-5 py-3.5 text-sm font-black text-gray-700 focus:outline-none focus:border-sky-400 bg-white appearance-none uppercase tracking-widest"
                    >
                      <option value="index, follow">INDEX, FOLLOW (ÖNERİLEN)</option>
                      <option value="noindex, follow">NOINDEX, FOLLOW</option>
                      <option value="index, nofollow">INDEX, NOFOLLOW</option>
                      <option value="noindex, nofollow">NOINDEX, NOFOLLOW</option>
                    </select>
                    <span className="pointer-events-none absolute right-5 top-1/2 -translate-y-1/2 text-gray-400 text-xs shadow-none">▼</span>
                  </div>
               </div>
            </div>
          </div>

          <button 
            onClick={() => { setKayit(true); setTimeout(() => setKayit(false), 2500); }}
            className={`w-full py-5 rounded-[2rem] text-sm font-black shadow-2xl transition-all hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest ${
              kayit ? 'bg-emerald-500 text-white shadow-emerald-200' : 'bg-gradient-to-r from-sky-500 rotate-0 to-blue-700 text-white shadow-sky-100 hover:shadow-sky-200'
            }`}
          >
            {kayit ? '✅ AYARLAR GÜNCELLENDİ' : '💾 SEO AYARLARINI KAYDET'}
          </button>
        </div>
      </div>

      <UsageInfo 
        color="sky"
        description="SEO (Arama Motoru Optimizasyonu), web sitenizin Google ve benzeri arama motorlarında ne kadar üst sıralarda görüneceğini belirler. Buradaki veriler arama sonuç ekranında doğrudan misafirlerinize sunulur."
        scenarios={[
          { title: "Title (Başlık) Seçimi", content: "Başlığınızın 60 karakteri geçmemesine özen gösterin. Önemli anahtar kelimenizi (Örn: Antalya Balayı Oteli) ilk kelime olarak kullanmak avantaj sağlar." },
          { title: "Karakter Sınırları", content: "Description (Açıklama) kısmı 160 karakterden uzun olursa, Google sonuna üç nokta (...) koyarak keser. En vurucu cümlenizi ilk 150 karakterde kurun." },
          { title: "Robots Direktifleri", content: "Eğer sitenizin henüz Google'da taranmasını istemiyorsanız 'noindex, nofollow' seçeneğini kullanabilirsiniz. Normal şartlarda 'index, follow' kalmalıdır." }
        ]}
      />

      <style>{`
        @keyframes fadeIn { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
      `}</style>
    </div>
  );
}